import React, {useState} from 'react';

import {Alert} from 'bonprix-design-system';

import PreSignUpForm from './PreSignUpForm.jsx';
import PageContainer from '../../common/PageContainer.jsx';
import BackButton from '../../common/BackButton.jsx';
import FootNotes from '../../common/FootNotes.jsx';
import {urls} from '../urlHelper.js';

export default function PreSignUpPage({
    texts,
    siteKeyPresignup,
    isCaptchaEnabled,
    isCaptchaV2Enabled,
    captchaLang,
    isGuestCheckoutEnabled,
    isGuestNewsletterEnabled,
    guestLoginPageLandmark,
    preSignUpPageLandmark,
}) {
    const [guest, setGuest] = useState(false);

    const [globalError, setGlobalError] = useState('');
    const footNotes = createFootNotesToDisplay();

    function createFootNotesToDisplay() {
        const footnotes = [texts['cus__presignup_footnote_required_field']];

        if (!displayNewsletter()) {
            return footnotes;
        }
        // Add benefit footnotes only if related benefit is displayed
        if (texts['cus__presignup_newsletter_benefit_1']?.trim().length > 0) {
            footnotes.push(texts['cus__presignup_footnote_newsletter_benefit_1']);
        }
        if (texts['cus__presignup_newsletter_benefit_2']?.trim().length > 0) {
            footnotes.push(texts['cus__presignup_footnote_newsletter_benefit_2']);
        }

        footnotes.push(texts['cus__presignup_footnote_newsletter']);
        return footnotes;
    }

    const toggleGuest = () => {
        setGuest((prevState) => !prevState);
    };

    function displayNewsletter() {
        return !guest || isGuestNewsletterEnabled;
    }

    return (
        <PageContainer>
            {globalError && (
                <Alert status="error" isOpen showCloseIcon onClose={() => setGlobalError('')}>
                    {globalError}
                </Alert>
            )}
            <PreSignUpForm
                texts={texts}
                siteKeyPresignup={siteKeyPresignup}
                isCaptchaEnabled={isCaptchaEnabled}
                isCaptchaV2Enabled={isCaptchaV2Enabled}
                captchaLang={captchaLang}
                isGuestCheckoutEnabled={isGuestCheckoutEnabled}
                onGlobalError={(data) => setGlobalError(data)}
                guestLoginPageLandmark={guestLoginPageLandmark}
                preSignUpPageLandmark={preSignUpPageLandmark}
                isGuest={guest}
                onGuestSwitchToggle={toggleGuest}
                isShowNewsletter={displayNewsletter()}
            />
            <div className="px-2.5 pb-safe-area-inset">
                <BackButton label={texts['bff_back_to_cart']} url={urls.CART_URL} />
                <FootNotes notes={footNotes} separator />
            </div>
        </PageContainer>
    );
}
